import React from 'react';

import StringUtils from '../../../common/utils/StringUtils';

import DataItemView from '../../../common/view/DataItemView';
import ModifiedFlag from '../../../common/controls/ModifiedFlag';
import ErrorFlag from '../../../common/controls/ErrorFlag';

import ContractAlertListView from './ContractAlertListView';
import ContractRangeListView from './ContractRangeListView';
import ParametersView from './ParametersView';

import BooleanEditor from '../../../common/metadata/BooleanEditor';
import CutOffEditor from '../../../common/metadata/CutOffEditor';
import NumberEditor from '../../../common/metadata/NumberEditor';
import SataConfigurationEditor from '../../../common/metadata/SataConfigurationEditor';
import SelectEditor from '../../../common/metadata/SelectEditor';
import StringEditor from '../../../common/metadata/StringEditor';

export default class ContractView extends DataItemView {
  static displayName = ContractView.name;

  constructor(props) {
    super(props);
    this.onEditorValueListener = this.onEditorValueChanged.bind(this);
    this.bindDataItem(props.contract);
  }

  componentDidUpdate() {
    this.bindDataItem(this.props.contract);
  }

  render() {
    if (!this.state.isDataBound)
      return (
        <div>
          <table><tbody><tr>
            <td valign="top">
              <div className="pwx-contract-view-container" />
            </td>
          </tr></tbody></table>
        </div>
      );
    
    return (
      <div className={this.getContractViewClassNames(this.state.isDeleted)}>
        <div className="pwx-view-header">
          <span className="pwx-view-title">{this.resolveViewTitle(this.state.code, this.state.displayName)}</span>
          <span>&nbsp;</span>
          <span className="pwx-modified-flag dx-icon-rename" hidden={!this.state.isModified} />
          <span className="pwx-error-flag dx-icon-warning" hidden={!this.state.hasErrors} />
          <span className="pwx-update-flag dx-icon-clear" hidden={!StringUtils.isNonEmptyString(this.state.updateErrorMessage)} title={this.state.updateErrorMessage} />
        </div>
        <div className="pwx-contract-view-content">
          <table><tbody>
            <tr className="pwx-field">
              <td className="pwx-field-label">Code:</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <StringEditor name="code" value={this.state.code} onValueChanged={this.onEditorValueListener} />
                <ModifiedFlag isModifiedProperty={this.state.code_isModified} />
                <ErrorFlag errorProperty={this.state.code_error} />
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Display Name:</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <StringEditor name="displayName" value={this.state.displayName} onValueChanged={this.onEditorValueListener} />
                <ModifiedFlag isModifiedProperty={this.state.displayName_isModified} />
                <ErrorFlag errorProperty={this.state.displayName_error} />
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Counterparty Code:</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <StringEditor name="counterpartyCode" disabled={true} value={this.state.counterpartyCode} />
                <ModifiedFlag isModifiedProperty={this.state.counterpartyCode_isModified} />
                <ErrorFlag errorProperty={this.state.counterpartyCode_error} />
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Is Active:</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <BooleanEditor name="isActive" value={this.state.isActive} onValueChanged={this.onEditorValueListener} />
                <ModifiedFlag isModifiedProperty={this.state.isActive_isModified} />
                <ErrorFlag errorProperty={this.state.isActive_error} />
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Input Data Channel:</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <table><tbody><tr>
                  <td className="pwx-select-box">
                    <SelectEditor
                      options={this.state.inputDataChannel_options}
                      displayExpr="displayValue"
                      height="28px"
                      name="inputDataChannel"
                      showClearButton={false}
                      value={this.state.inputDataChannel}
                      onValueChanged={this.onEditorValueListener}
                      width="180px"
                    />
                  </td>
                  <td>
                    <ModifiedFlag isModifiedProperty={this.state.inputDataChannel_isModified} />
                    <ErrorFlag errorProperty={this.state.inputDataChannel_error} />
                  </td>
                </tr></tbody></table>
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Hourly Energy Maximum:</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <NumberEditor name="hourlyEnergyMaximum" value={this.state.hourlyEnergyMaximum} onValueChanged={this.onEditorValueListener} />
                <ModifiedFlag isModifiedProperty={this.state.hourlyEnergyMaximum_isModified} />
                <ErrorFlag errorProperty={this.state.hourlyEnergyMaximum_error} />
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Hourly Energy Minimum:</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <NumberEditor name="hourlyEnergyMinimum" value={this.state.hourlyEnergyMinimum} onValueChanged={this.onEditorValueListener} />
                <ModifiedFlag isModifiedProperty={this.state.hourlyEnergyMinimum_isModified} />
                <ErrorFlag errorProperty={this.state.hourlyEnergyMinimum_error} />
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Hourly Energy Non-Electable:</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <NumberEditor name="hourlyEnergyNonElectable" value={this.state.hourlyEnergyNonElectable} onValueChanged={this.onEditorValueListener} />
                <ModifiedFlag isModifiedProperty={this.state.hourlyEnergyNonElectable_isModified} />
                <ErrorFlag errorProperty={this.state.hourlyEnergyNonElectable_error} />
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Trade Cut-off Time:</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <table><tbody><tr>
                  <td>
                    <CutOffEditor name="tradeCutOffTime" value={this.state.tradeCutOffTime} onValueChanged={this.onEditorValueListener} />
                  </td>
                  <td>
                    <ModifiedFlag isModifiedProperty={this.state.tradeCutOffTime_isModified} />
                    <ErrorFlag errorProperty={this.state.tradeCutOffTime_error} />
                  </td>
                </tr></tbody></table>
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Trade Cut-off Warning:</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <NumberEditor name="tradeCutOffWarning" value={this.state.tradeCutOffWarning} onValueChanged={this.onEditorValueListener} />
                &nbsp;second(s)
                <ModifiedFlag isModifiedProperty={this.state.tradeCutOffWarning_isModified} />
                <ErrorFlag errorProperty={this.state.tradeCutOffWarning_error} />
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Subhourly Resolution:</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <table><tbody><tr>
                  <td className="pwx-select-box">
                    <SelectEditor
                      options={this.state.subhourlyResolution_options}
                      displayExpr="displayValue"
                      height="28px"
                      name="subhourlyResolution"
                      showClearButton={false}
                      value={this.state.subhourlyResolution}
                      onValueChanged={this.onEditorValueListener}
                      width="90px"
                    />
                  </td>
                  <td>
                    <ModifiedFlag isModifiedProperty={this.state.subhourlyResolution_isModified} />
                    <ErrorFlag errorProperty={this.state.subhourlyResolution_error} />
                  </td>
                </tr></tbody></table>
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Election Range:</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <table><tbody>
                  <tr>
                    <td className="pwx-select-box">
                      <SelectEditor
                        options={this.state.electionRange_options}
                        displayExpr="displayValue"
                        height="28px"
                        name="electionRange"
                        showClearButton={false}
                        value={this.state.electionRange}
                        onValueChanged={this.onEditorValueListener}
                        width="195px"
                      />
                    </td>
                    <td>
                      <ModifiedFlag isModifiedProperty={this.state.electionRange_isModified} />
                      <ErrorFlag errorProperty={this.state.electionRange_error} />
                    </td>
                  </tr>
                </tbody></table>
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Show Contract Limits:</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <BooleanEditor name="showContractLimits" value={this.state.showContractLimits} onValueChanged={this.onEditorValueListener} />
                <ModifiedFlag isModifiedProperty={this.state.showContractLimits_isModified} />
                <ErrorFlag errorProperty={this.state.showContractLimits_error} />
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Enforce Package Rules:</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <table><tbody>
                  <tr>
                    <td className="pwx-select-box">
                      <SelectEditor
                        options={this.state.enforcePackageRules_options}
                        displayExpr="displayValue"
                        height="28px"
                        name="enforcePackageRules"
                        showClearButton={false}
                        value={this.state.enforcePackageRules}
                        onValueChanged={this.onEditorValueListener}
                        width="160px"
                      />
                    </td>
                    <td>
                      <ModifiedFlag isModifiedProperty={this.state.enforcePackageRules_isModified} />
                      <ErrorFlag errorProperty={this.state.enforcePackageRules_error} />
                    </td>
                  </tr>
                </tbody></table>
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Prince Code (A):</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <StringEditor name="princeSubmissionACode" value={this.state.princeSubmissionACode} onValueChanged={this.onEditorValueListener} />
                <ModifiedFlag isModifiedProperty={this.state.princeSubmissionACode_isModified} />
                <ErrorFlag errorProperty={this.state.princeSubmissionACode_error} />
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Prince Code (B):</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <StringEditor name="princeSubmissionBCode" value={this.state.princeSubmissionBCode} onValueChanged={this.onEditorValueListener} />
                <ModifiedFlag isModifiedProperty={this.state.princeSubmissionBCode_isModified} />
                <ErrorFlag errorProperty={this.state.princeSubmissionBCode_error} />
              </td>
            </tr>
            <tr className="pwx-field">
              <td className="pwx-field-label">Sata Configuration:</td>
              <td className="pwx-field-spacer" />
              <td className="pwx-field-value">
                <table><tbody><tr>
                  <td>
                    <SataConfigurationEditor name="sataConfiguration" value={this.state.sataConfiguration} onValueChanged={this.onEditorValueListener} />
                  </td>
                  <td>
                    <ModifiedFlag isModifiedProperty={this.state.sataConfiguration_isModified} />
                    <ErrorFlag errorProperty={this.state.sataConfiguration_error} />
                  </td>
                </tr></tbody></table>
              </td>
            </tr>
          </tbody></table>

          <div className="pwx-center-align">
            <ContractRangeListView contractRangeList={this.state.contractRanges} />
          </div>

          <ParametersView parameters={this.state.parameters} />
          <div className="pwx-center-align">
            <ContractAlertListView contractAlertList={this.state.alerts} />
          </div>
        </div>
      </div>
    
    );
  }

  getContractViewClassNames(isDeleted) {
    var classNames = 'pwx-contract-view-container pwx-contract-view';
    if (isDeleted)
      classNames += ' pwx-item-deleted';

    return classNames;
  }

  resolveViewTitle(code, displayName) {
    var useCode = StringUtils.isNonEmptyString(code);
    var useDisplayName = StringUtils.isNonEmptyString(displayName);

    if (useCode && useDisplayName)
      return `${displayName} (${code})`;

    if (useCode)
      return code;

    if (useDisplayName)
      return displayName;

    return 'Contract Details';
  }

  onEditorValueChanged(propertyName, value) {
    if (this.dataItem !== null)
      this.dataItem.updateProperty(propertyName, value);
  }
}